/* eslint-disable no-console */
const parseData = (data) => {
  try {
    const { data: socketData = {}, channel: socketChannel, type: messageType } = JSON.parse(data);
    return { socketData, socketChannel, messageType };
  } catch (error) {
    console.error('ERROR: progressSocket: parseData()', error);
    return {};
  }
};

const createSocket = ({ url, channel, subscribeData, onMessage }) => {
  const websocket = new WebSocket(url);
  let subscribed = false;

  websocket.onmessage = ({ data }) => {
    const { socketData, socketChannel, messageType } = parseData(data);
    if (channel !== socketChannel) { return; }
    switch (messageType) {
      case 'subscription/confirmation':
        subscribed = true;
        break;
      case 'subscription/message':
        if (subscribed) { onMessage(socketData); }
        break;
      default:
    }
  };

  websocket.onopen = () => {
    try {
      websocket.send(JSON.stringify(subscribeData));
    } catch (error) {
      console.error('ERROR: progressSocket: onOpen()', error);
    }
  };

  websocket.onclose = () => {
    subscribed = false;
  };

  websocket.isSubscribed = () => subscribed;

  return websocket;
};

export { createSocket };
